import { event } from '@uhg-abyss/web/tools/event';

export const adobeSearchFilterEvent = (input) => {
  event('SEARCH_FILTER_EVENT', {
    search: {
      term: input.term?.toLowerCase() ?? '',
      type: input.isGuest ? input.type ?? 'site' : 'provider',
      filters: input?.filters || '',
    },
    component: {
      name: '',
    },
  });
};
